import "./styles.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
// import { FaLock } from "react-icons/fa6";
import { ApiCollection } from "../../../config/envConfig";
import { useAxios } from "../../../hooks/useAxios";
import SpinnerLoader from "../../../components/loader";
import { Subject } from "../../../utils/interface/subject";
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import { Colors } from "../../../utils/constants/colors";

export default function SubjectListScreen() {
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState<Subject[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const axios = useAxios();


  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/') {
      navigate('/subject')
    }
    fetchSubjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchSubjects = async () => {
    setIsLoading(true);
    await axios.get(ApiCollection.subject.getList)
      .then((response) => {
        setSubjects(response.data.subject);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching subjects:', error);
        setIsLoading(false);
      })
  };

  const handleSubjectClick = (subject: Subject) => {
    navigate(`/subject/view?subjectId=${subject.id}&title=${subject.subject}`);
  };



  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh', width: '100%' }}>
        <SpinnerLoader />
        <h2 style={{ marginTop: 10, fontSize: 20 }}>
          Loading Subjects...
        </h2>
      </div>
    )

  }


  return (
    <div className="container">

      <div className="subject_grid">
        <h1 className="pageHeading subjects">Available Subjects</h1>

        {subjects.map((subject) => (
          <div
            key={subject?.id}
            className="subject_card"
            onClick={() => handleSubjectClick(subject)}
          >
            <div className="image_wrapper">
              <img
                src={subject?.subject_logo}
                alt={subject?.subject}
                className="subject_image"
              />
            </div>
            <div className="subject_details">
              <div className="data">

                <h2 className="subject_title">{subject.subject}</h2>
                <p>{subject.grade_level} {subject.board}</p>
              </div>
              {subject.is_unlocked && <IoCheckmarkCircleSharp size={22} style={{ marginRight: 10 }} color={Colors.primary} />}

            </div>
          </div>
        ))}
      </div>


    </div>
  );
}